//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  CREAR_PACIENTE,
  ASIGNAR_PACIENTE
} from "@/graphql/mutations/pacientes.js";
import {
  GET_PACIENTE_BY_ID,
  GET_ALL_ENFERMEDADES,
  GET_TIPOS_VIA,
  GET_NIVELES_INSTRUCCION
} from "@/graphql/queries/pacientes.js";
import EventBus from "@/event-bus.js";
import { contextualHelp } from "@/utils/contextualHelp.js";
import { date } from "quasar";

export default {
  name: "PacientesCrud",
  apollo: {
    enfermedades: {
      query: GET_ALL_ENFERMEDADES,
      update(data) {
        if (data.findAllEnfermedades) {
          console.log(data.findAllEnfermedades);
          return data.findAllEnfermedades;
        }
        return [];
      },
      skip() {
        return false;
      }
    },
    tiposVia: {
      query: GET_TIPOS_VIA,
      update(data) {
        if (data.findTiposVia) {
          console.log(data.findTiposVia);
          return data.findTiposVia;
        }
        return [];
      },
      skip() {
        return false;
      }
    },
    nivelesInstruccion: {
      query: GET_NIVELES_INSTRUCCION,
      update(data) {
        if (data.findNivelesInstruccion) {
          console.log(data.findNivelesInstruccion);
          return data.findNivelesInstruccion;
        }
        return [];
      },
      skip() {
        return false;
      }
    }
  },
  async mounted() {
    EventBus.$emit("page-loaded", { page: "PacientesCrud" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["PacientesCrud"]
    });
    if (this.$route.params.id !== "_") {
      this.create = false;
      let res = await this.$apollo.query({
        query: GET_PACIENTE_BY_ID,
        variables: {
          id: +this.$route.params.id
        }
      });
      let data = res.data.findPacienteById;
      this.id = data.id;
      this.dni = data.dni;
      this.nombre = data.nombre;
      this.primer_apellido = data.primer_apellido;
      this.segundo_apellido = data.segundo_apellido;
    }
  },
  data() {
    return {
      valid: false,
      id: null,
      dni: "",
      nombre: "",
      primer_apellido: "",
      segundo_apellido: "",
      email: "",
      telefono: "",
      fecha_nacimiento: "",
      sexo: "",
      fecha_diagnostico: "",
      nivel_instruccion: "",
      confirmAsign: false,
      create: true,
      messageAsign: "¿Desea asignarse este paciente?",
      credenciales: null,
      downloadCredentialsModal: false,
      showCredentials: true,
      enfermedades: [],
      enfermedadesSelected: {},
      sexos: [
        {
          id: "H",
          descripcion: "Hombre"
        },
        {
          id: "M",
          descripcion: "Mujer"
        }
      ],
      domicilio: {}
    };
  },
  computed: {
    formRules() {
      return {
        required: value => !!value || "Obligatorio",
        regex: v =>
          /^[0-9]{8,8}[A-Za-z]$/.test(v) ||
          /[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]/.test(v) ||
          "DNI/NIE debe cumplir el formato"
      };
    },
    modeLabel() {
      return this.create ? "Alta de Paciente" : "Actualización de Paciente";
    },
    submitLabel() {
      return this.create ? "Añadir Paciente" : "Editar Paciente";
    }
  },
  methods: {
    async submit() {
      let success = await this.$refs.form.validate();
      if (success) {
        console.log(`Creando nuevo paciente`);
        this.$q.loading.show({
          message:
            "Dando de alta un nuevo paciente... <br/><span>Espere...</span>"
        });
        try {
          const fecha_nacimiento_date = date.extractDate(
            this.fecha_nacimiento,
            "DD/MM/YYYY"
          );
          const fecha_diagnostico_date = date.extractDate(
            this.fecha_diagnostico,
            "DD/MM/YYYY"
          );
          const usernamePassword = await this.$apollo.mutate({
            mutation: CREAR_PACIENTE,
            variables: {
              dni: this.dni,
              nombre: this.nombre,
              primer_apellido: this.primer_apellido, // this should be the same name as the one the server is expecting
              segundo_apellido: this.segundo_apellido,
              email: this.email,
              telefono: this.telefono, // this should be the same name as the one the server is expecting
              fecha_nacimiento: fecha_nacimiento_date
                ? date.formatDate(fecha_nacimiento_date, "YYYY-MM-DD")
                : null,
              sexo: this.sexo ? this.sexo.id : null,
              fecha_diagnostico: fecha_diagnostico_date
                ? date.formatDate(fecha_diagnostico_date, "YYYY-MM-DD")
                : null,
              nivel_instruccion: this.nivel_instruccion.id,
              enfermedades: this.enfermedadesSelected.id,
              domicilio: this.domicilio
            }
          });
          if (usernamePassword.data.createPaciente.alreadyExistsAsOther) {
            await this.asignarPaciente();
            this.messageAsign = "El paciente ya había sido creado previamente";
            this.$q.notify({
              position: "top-right",
              message: this.messageAsign,
              color: "warning"
            });
            // this.confirmAsign = true;
            this.showCredentials = false;
            return;
          }
          if (!usernamePassword.data.createPaciente.alreadyExists) {
            await this.asignarPaciente();
            this.$q.notify({
              position: "top-right",
              message: "Paciente creado correctamente",
              color: "positive"
            });
            //this.messageAsign = "¿Desea asignarse este paciente?";
            //this.confirmAsign = true;
            this.credenciales = usernamePassword.data.createPaciente.file;
          } else {
            await this.asignarPaciente();
            this.messageAsign = "El paciente ya había sido creado previamente";
            // this.confirmAsign = true;
            this.$q.notify({
              position: "top-right",
              message: this.messageAsign,
              color: "warning"
            });
            this.showCredentials = false;
          }
        } catch (e) {
          console.log(e.message);
          this.$q.notify({
            position: "top-right",
            message: e.message,
            color: "negative"
          });
        } finally {
          this.$q.loading.hide();
        }
      } else {
        console.error(`Modelo no correcto`);
      }
    },
    async asignarPaciente() {
      let user = this.$store.getters["auth/getUser"];
      try {
        await this.$apollo.mutate({
          mutation: ASIGNAR_PACIENTE,
          variables: {
            id_medico: user.internal.id,
            dni_paciente: this.dni
          }
        });
        this.$q.notify({
          position: "top-right",
          message: "El paciente ha sido asignado correctamente",
          color: "positive"
        });
      } catch (e) {
        this.$q.notify({
          position: "top-right",
          message: "Este paciente ya es su paciente",
          color: "negative"
        });
      } finally {
        this.downloadCredentialsShowModal();
        //this.next();
      }
    },
    downloadCredentialsShowModal() {
      if (this.showCredentials) {
        this.downloadCredentialsModal = true;
      }
    },
    async descargarCredenciales() {
      if (this.credenciales) {
        const downloadLink = document.createElement("a");
        const fileName = `${this.uuidv4()}.pdf`;

        downloadLink.href = this.credenciales;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    next() {
      this.$router.push("/pacientes");
    }
  }
};
